import { useUser } from "contexts/UserContext";
import AdminRoutes from "./AdminRoutes";
import ContentAdminRoutes from "./ContentAdminRoutes";
import CustomerServiceRoutes from "./CustomerServiceRoutes";
import PublicRoutes from "./PublicRoutes";
import EndUserRoutes from "./EndUserRoutes";

export function RouteList() {
  const user = useUser(false);

  if (!user) {
    return <PublicRoutes />;
  }

  if (user.isContentAdmin) {
    return <ContentAdminRoutes />;
  }

  if (user.isAdmin) {
    return <AdminRoutes />;
  }

  if (user.isCustomerService) {
    return <CustomerServiceRoutes />;
  }

  return <EndUserRoutes />;
}
